(() => {
  const root = document.querySelector('[data-dietz-halloween-popup]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  const launcher = root.querySelector('[data-halloween-open]');
  const wheel = root.querySelector('dietz-halloween-wheel');
  const seenKey = 'dietz_halloween_2026_popup_seen';
  let timer, state, scheduled = false;
  const seen = () => { try { return localStorage.getItem(seenKey) === 'true'; } catch { return false; } };
  const label = claimed => {
    launcher.setAttribute('aria-label', claimed ? 'Abrir mi premio de Halloween' : 'Abrir la ruleta de Halloween');
    launcher.setAttribute('title', claimed ? 'Tu premio' : 'Gira y gana');
  };
  const open = () => {
    if (!state?.enabled && !state?.claim || dialog.open) return;
    dialog.showModal();
    const title = wheel.shadowRoot?.querySelector('.title');
    if (title) {
      title.tabIndex = -1;
      title.focus({ preventScroll: true });
    }
    document.body.classList.add('dietz-halloween-open');
    try { localStorage.setItem(seenKey, 'true'); } catch (_) {}
  };
  launcher.addEventListener('click', open);
  root.querySelector('[data-halloween-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.body.classList.remove('dietz-halloween-open');
    launcher.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  const update = detail => {
    state = detail;
    launcher.hidden = !(detail.claim || detail.enabled);
    label(Boolean(detail.claim));
    if (scheduled || seen() || launcher.hidden || detail.claim) return;
    scheduled = true;
    const tryOpen = () => {
      if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]')) { timer = setTimeout(tryOpen, 1500); return; }
      open();
    };
    timer = setTimeout(tryOpen, 5000);
  };
  wheel.addEventListener('dietz:participation', event => update(event.detail));
  wheel.addEventListener('dietz:spin-result', () => label(true));
  if (wheel.participation) update(wheel.participation);
  const pauseMotion = () => { root.dataset.motionPaused = String(document.hidden); };
  document.addEventListener('visibilitychange', pauseMotion);
  pauseMotion();
  window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
})();
